import { sitemapPageQuery } from '@queries/pages/sitemap';
import { mapSitemapPageData } from '@lib/page-data/sitemap.map';
import { withServerSideProps } from '@lib/withServerSideProps';
import AMS from '@ui/components/ams';
import Page from '@ui/components/ams/Pages/Page';

const SitemapPage = ({
  globalPageData,
  pageData,
  userSessionData,
  requestData,
  locale,
}) => {
  const {
    metaDescription,
    pageTitle,
    globalPageConfig,
    siteMapPageData,
    allCategoriesData,
    shopOrder,
    footersData,
    navCategoryBarData,
    allSeasonalLinks,
  } = pageData;

  return (
    <Page
      pageTitle={pageTitle}
      metaDescription={metaDescription}
      globalPageData={globalPageData}
      requestData={requestData}
      userSessionData={userSessionData}
    >
      <AMS.SiteMapPageContent
        locale={locale}
        globalPageConfig={globalPageConfig}
        siteMapPageData={siteMapPageData}
        allCategoriesData={allCategoriesData}
        shopOrder={shopOrder}
        footersData={footersData}
        navCategoryBarData={navCategoryBarData}
        seasonalPageData={allSeasonalLinks}
        urlData={requestData.urlData}
      />
    </Page>
  );
};

export const getServerSideProps = withServerSideProps({
  pageQuery: sitemapPageQuery,
  pageDataMapper: mapSitemapPageData,
});

export default SitemapPage;
